import { IDriversQuery } from '../interfaces/driver.interface';
import { PATHS } from '../const/paths.constants';
import { EApiPaths } from '../enums/api-paths.enum';
import { API as API_DASHBACK } from './config-dashback.api';
import { API } from './config-service.api';

const path = EApiPaths.DELIVERY_PARTNER;

export const addDriver = (payload: any) => API_DASHBACK.post(`${path}/addDriver`, payload);

export const removeDriver = (payload: any) => API_DASHBACK.post(`${path}/removeDriver`, payload);

export const resendInvitation = (userID: any) => {
    const route = `${path}/resendDriverInvitation?userID=${userID}`;
    return API_DASHBACK.post(route);
};

export const oldUpdateDriver = (payload: any) => API_DASHBACK.post(`${path}/editDriver`, payload);

// New API
export const getDrivers = (query: IDriversQuery) => API.get(PATHS.DRIVERS, {
    params: query,
    paramsSerializer: (params) => {
        const searchParams = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach((v) => searchParams.append(key, v));
            } else if (value !== undefined && value !== null) {
                searchParams.append(key, String(value));
            }
        });
        return searchParams.toString();
    },
});

export const getDriverById = (id: string) => API.get(`${PATHS.DRIVERS}/${id}`);

export const updateDriver = (id: string, payload: any) => API.put(`${PATHS.DRIVERS}/${id}`, payload);
